enum SiteMeta {
  SET_SITE_META_INITIALIZE = 'SET_SITE_META_INITIALIZE',
  SET_SITE_META_INFO = 'SET_SITE_META_INFO'
}

export default SiteMeta;
